// src/pages/PrivacyPolicy/PrivacyPolicyPage.tsx
import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{
        fontSize: '2.5em',
        marginBottom: '30px',
        textAlign: 'center',
        color: '#1a1a1a'
      }}>
        Privacy Policy
      </h1>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          1. Information Collection
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We collect information that you provide directly to us, including but not limited to:
        </p>
        <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
          <li>Name and contact information</li>
          <li>Property preferences and search history</li>
          <li>Communication records</li>
          <li>Account credentials</li>
        </ul>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          2. Use of Information
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We use the collected information to:
        </p>
        <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
          <li>Provide and improve our real estate services</li>
          <li>Process your property inquiries</li>
          <li>Send you relevant property listings and updates</li>
          <li>Communicate with you about our services</li>
          <li>Ensure platform security and prevent fraud</li>
        </ul>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          3. Information Sharing
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We do not sell your personal information. We may share your information with:
        </p>
        <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
          <li>Property owners or agents when you express interest in a property</li>
          <li>Service providers who assist in our operations</li>
          <li>Legal authorities when required by law</li>
        </ul>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          4. Data Security
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We implement appropriate security measures to protect your personal information from
          unauthorized access, alteration, disclosure, or destruction. However, no method of
          transmission over the internet is 100% secure.
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          5. Your Rights
        </h2>
        <p style={{ marginBottom: '15px' }}>
          You have the right to:
        </p>
        <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of marketing communications</li>
        </ul>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          6. Cookies and Tracking
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We use cookies and similar tracking technologies to enhance your experience,
          analyze usage patterns, and personalize content. You can control cookie preferences
          through your browser settings.
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          7. Changes to Privacy Policy
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We may update this privacy policy from time to time. We will notify you of any
          significant changes by posting the new policy on this page with an updated revision date.
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{
          fontSize: '1.8em',
          marginTop: '30px',
          marginBottom: '15px',
          color: '#2c3e50'
        }}>
          8. Contact Us
        </h2>
        <p style={{ marginBottom: '15px' }}>
          If you have any questions or concerns about this privacy policy or our data practices,
          please contact us at:
        </p>
        <p style={{ marginLeft: '20px' }}>
          <strong>Zwe Htet Real Estate</strong><br />
          Email: contact@zwehtet.com<br />
          Phone: +95 9 XXX XXX XXX
        </p>
      </div>

      <div style={{
        marginTop: '50px',
        paddingTop: '20px',
        borderTop: '1px solid #ddd',
        textAlign: 'center',
        color: '#666',
        fontSize: '0.9em'
      }}>
        <p>Last Updated: {new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
